import { isChunkLoadError } from 'lib/tracking/helpers/isChunkLoadError/isChunkLoadError'

interface IsAutoCapturedChunkLoadErrorParams {
  source: string
  message: string
}

/**
 * True when a RUM chunk-load error was auto-captured rather than reported by the app itself.
 *
 * A stale-deploy chunk miss reaches RUM from three directions at once: Turbopack swallows a
 * page-chunk miss into its own `console.error` (`source: console`), the browser reports an unhandled
 * dynamic-import rejection (`source: source`), and `recoverFromChunkLoadError` reloads the page to
 * recover. The first two are duplicate reports of a fault the app already handles, so they are noise.
 *
 * Requiring a non-`custom` source keeps the one chunk report worth alerting on: `logError` from
 * `recoverFromChunkLoadError`'s skip path (`source: custom`), which fires only when a reload could
 * *not* — i.e. the chunk is still missing after one, meaning a genuinely broken deploy or CDN.
 */
export const isAutoCapturedChunkLoadError = ({ source, message }: IsAutoCapturedChunkLoadErrorParams): boolean =>
  source !== 'custom' && isChunkLoadError({ message })
